/**
 * ChipFab — Fully assembled Chip.
 *
 * Pass label, selected, size, optional icon — colors resolved internally.
 * For full control, use the primitive Chip + ChipText instead.
 */
import type { LucideIcon } from 'lucide-react-native'
import type { GetProps } from 'tamagui'
import { Chip, ChipText } from '../elements/Chip'

const ICON_SIZE: Record<string, number> = {
  sm: 12,
  md: 14,
}

type ChipFrameProps = GetProps<typeof Chip>

interface ChipFabProps extends Omit<ChipFrameProps, 'children'> {
  label: string
  icon?: LucideIcon
  iconAfter?: LucideIcon
}

export function ChipFab({
  label,
  icon: Icon,
  iconAfter: IconAfter,
  selected,
  size = 'md',
  ...props
}: ChipFabProps) {
  const textColor = selected ? '$colorInverse' : '$color'
  const iconColor = selected ? '$colorInverse' : '$colorSecondary'
  const iconSize = ICON_SIZE[size] ?? 14

  return (
    <Chip selected={selected} size={size} {...props}>
      {Icon && <Icon size={iconSize} color={iconColor} />}
      <ChipText color={textColor} size={size}>{label}</ChipText>
      {IconAfter && <IconAfter size={iconSize} color={iconColor} />}
    </Chip>
  )
}
